import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from 'react-bootstrap';

const CategoryList = [
    { name: 'Advanced Business Strategies' },
    { name: 'High-Income Skills' },
    { name: 'Money Management & Investing' },
    { name: 'Online Business Mastery' },
    { name: 'Leadership & Influence' },
    { name: 'Goal Setting & Execution' },
    { name: 'Mindset for Success' },
    { name: 'Startup & Innovation' },
    { name: 'Career Growth & Transition' },
    { name: 'Sales & Persuasion Techniques' },
];

const gradientStyle = {
    backgroundImage: 'linear-gradient(90deg, #7b2ff7, #f107a3)',
    color: 'white',
    border: 'none',
    padding: '12px 28px',
    borderRadius: '9999px',
    whiteSpace: 'nowrap',
    fontWeight: '600',
    fontSize: '2rem', // ~20px
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
};

const TrainingCategories = () => {
    return (
        <div className="d-flex flex-wrap gap-3 justify-content-center">
            {CategoryList.map((data, index) => (
                <Link to="#" key={index} style={{ textDecoration: 'none' }}>
                    <Button
                        style={gradientStyle}
                        className="text-white"
                        onMouseOver={e => {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 4px 15px rgba(241, 7, 163, 0.3)';
                        }}
                        onMouseOut={e => {
                            e.target.style.transform = 'none';
                            e.target.style.boxShadow = 'none';
                        }}
                    >
                        {data.name}
                    </Button>
                </Link>
            ))}
        </div>
    );
};

export default TrainingCategories;
